<template>
    <form-modal
        :name="modalName"
        :action="action"
        :method="method"
        :primary-button-text="buttonText"
        :callback="callback"
        :close-button-text="lang('Avbryt','Cancel')"
    >
        <div>
            <div v-if="success" class="border border-success text-success p-xl my-xl flex">
                <font-awesome-icon icon="check-circle" class="mr-xl" />
                <div>{{ success }}</div>
            </div>

            <div v-if="showCreateForm">
                <h3 class="mb-2xl">{{ lang('Meddela mig','Keep me informed') }}</h3>
                <p>
                    {{ lang(
                        'Fyll i ditt mobilnummer för att få löpande information om denna driftstatus direkt till din mobil.',
                        'Submit your mobile number to receive updates regarding this service status'
                    ) }}
                </p>

                <input
                    type="hidden"
                    name="subscribe"
                    value="1"
                >

                <text-input
                    v-model="number"
                    name="number"
                    type="tel"
                    :label="lang('Mobilnummer (på formatet 07xxxxxxxx)','Mobile number (format 07xxxxxxxx)')"
                    pattern="^07([0-9][ -]*){7}[0-9]$"
                    :title="lang('Ange numret på formatet: 07xxxxxxxx','Format your number: 07xxxxxxxx')"
                    :autofocus="true"
                />

                <div class="my-xl">
                    {{ lang('Redan prenumererad?','Already subscribed?') }} <a @click="toggle()">{{ lang('Avprenumerera mig','Unsubscribe') }}</a>
                </div>
            </div>
            <div v-else>
                <h3 class="mb-2xl">{{ lang('Ta bort prenumeration','Unsubscribe') }}</h3>
                <p>{{ lang('Fyll i ditt mobilnummer så tar vi bort din eventuella prenumeration på denna driftstatus','Submit your mobile number to unsubscribe from this service status') }}.</p>

                <input
                    type="hidden"
                    name="subscribe"
                    value="0"
                >

                <text-input
                    v-model="number"
                    name="number"
                    type="tel"
                    :label="lang('Mobilnummer (på formatet 07xxxxxxxx)','Mobile number (format 07xxxxxxxx)')"
                    pattern="^07([0-9][ -]*){7}[0-9]$"
                    :title="lang('Ange numret på formatet: 07xxxxxxxx','Submit your number format 07xxxxxxxx')"
                    :autofocus="true"
                />

                <div class="my-xl">
                    <a @click="toggle()">&laquo; {{ lang('Tillbaka','Back') }}</a>
                </div>
            </div>
        </div>
    </form-modal>
</template>

<script>
    export default {
        props: {
            serviceStatus: {
                type: Object,
                required: true,
            },
            modalName: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                number: '',
                showCreateForm: true,
                success: '',
            };
        },
        computed: {
            method() {
                if (this.showCreateForm) {
                    return 'post';
                } else {
                    return 'delete';
                }
            },
            action() {
                if (this.showCreateForm) {
                    return route('front.api.customer-service.service-status-subscriptions.store', this.serviceStatus);
                } else {
                    return route('front.api.customer-service.service-status-subscriptions.destroy', { serviceStatus: this.serviceStatus, number: this.number });
                }
            },
            buttonText() {
                return this.showCreateForm ? lang('Prenumerera','Subscribe') : lang('Avprenumerera','Unsubscribe');
            },
        },
        methods: {
            toggle() {
                this.showCreateForm = ! this.showCreateForm;
            },
            callback(response) {
                this.number = '';
                this.success = response.data.message;
            },
        },
    };
</script>
